module.exports = __webpack_public_path__ + "media/images/job-order-form-small2-9c261f9717865c3c732f6be6e15cd12d.png";